export default __webpack_public_path__ + "static/media/Seccion_promos_pasada_11_Septiembre.885994a9.webp";